import {useNavigate} from 'react-router-dom';
import {useTheme} from 'styled-components';
import {useTranslation} from 'react-i18next';
import {CustomIcon, IconNames} from '@guestapp/ui';
import {usePath} from 'hooks';
import {PATHS} from 'Routes';
import {useFetchGuidebooks} from 'hooks/guidebooks/useFetchGuidebooks';
import {useSummary} from 'context/summary';
import {
  Description,
  Header,
  HeaderDescription,
  HeaderTitle,
  Icon,
  Info,
  Item,
  List,
  NextArrow,
  NextArrowWrapper,
  Title,
  Wrapper,
} from './styled';

function GuidebooksNavigationList() {
  const {getFullPath} = usePath();
  const theme = useTheme();
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {reservationId} = useSummary();
  const {data} = useFetchGuidebooks({
    reservationId,
  });
  const guidebooks = data?.items;

  const handleNavigate = (guidebookId: string) => {
    navigate(getFullPath(`${PATHS.guidebook}/${guidebookId}`));
  };

  if (!guidebooks?.length) return null;

  return (
    <Wrapper className="guidebook-nav-list">
      <Header className="guidebook-nav-list__header">
        <HeaderTitle>{t('guidebooks')}</HeaderTitle>
        <HeaderDescription>{t('guidebooks_description')}</HeaderDescription>
      </Header>
      <List className="guidebook-nav-list__list">
        {guidebooks?.map(guidebook => (
          <Item
            className="guidebook-nav-list__item"
            onClick={() => handleNavigate(guidebook.guidebook_group_id)}
            key={guidebook.id}
          >
            <Icon className="guidebook__icon">
              <CustomIcon
                name={guidebook.icon as IconNames}
                size={24}
                color={theme.hasTemplate ? theme.colors.branding.icons : '#777E91'}
              />
            </Icon>
            <Info className="guidebook-nav-list__info">
              <Title className="guidebook-nav-list__item-title">{guidebook.title}</Title>
              <Description className="guidebook__item-description">
                {guidebook.description}
              </Description>
            </Info>
            <NextArrowWrapper className="guidebook-nav-list__arrow-wrapper">
              <NextArrow name="grayRightArrow" size={16} className="guidebook__arrow" />
            </NextArrowWrapper>
          </Item>
        ))}
      </List>
    </Wrapper>
  );
}

export {GuidebooksNavigationList};
